<div [class]="wrapperClass()">
  @if (showCheckbox()) {
    <mat-checkbox
      [checked]="selected()"
      [disabled]="!selectable()"
      [class.hidden]="!selectable()"
      (change)="selected.set($event.checked)"
    >
    </mat-checkbox>
  }
  <div class="wrapper-image">
    @if (!displayListView()) {
      <ui-product-labels
        [displayVertically]="true"
        [product]="product()"
        [groups]="badgeLabelGroups()"
        class="badge-labels-grid"
      ></ui-product-labels>
    }

    <a [link]="product()" uiProductLink [enableProductClickTracking]="enableProductClickTracking()" [position]="position()">
      @if (product().images.length) {
        <img [alt]="product().images[0].large" [src]="product().images[0].large">
      }
    </a>

    @if (!displayListView()) {
      <div class="wrapper-labels">
        <ui-product-labels [product]="product()" [groups]="iconLabelGroups()"></ui-product-labels>
      </div>
    }
  </div>

  <div class="wrapper-content">
    <div class="product-info">
      <a [link]="product()" uiProductLink [enableProductClickTracking]="enableProductClickTracking()">
        <span class="product-name" title="{{ product().details.name }}">{{ product().details.name }}</span>
      </a>

      <span class="product-manufacturer">{{ product().details.manufacturer }}</span>

      @if (displayListView()) {
        <ui-product-labels
          class="icon-labels-row"
          [product]="product()"
          [groups]="['product-icons']">
        </ui-product-labels>
      }
    </div>
  </div>

  <div class="wrapper-attributes swiper-no-swiping">
    @if (displayListView()) {
      <ui-product-labels
        [product]="product()"
        [groups]="badgeLabelGroups()"
        [displayVertically]="true"
      ></ui-product-labels>
    }
    @if (showAttributes()) {
      @if (product().bundleType === 'closed') {
        <div class="wrapper-max-order-count">
          @let maxOrderCount = product().bundle?.maxOrderCount ?? 0;
          Maximal {{ maxOrderCount }} {{ maxOrderCount > 1 ? 'Pakete' : 'Paket' }} pro Kunde
        </div>
      } @else if (attributesTemplate(); as attributes) {
        <ng-container [ngTemplateOutlet]="attributes"></ng-container>
      } @else {
        <ui-product-card-attributes
          [showAdditionalData]="displayListView() && !product().bundleType"
          [product]="product()">
        </ui-product-card-attributes>
      }
    }
  </div>
</div>
